import Vue from 'vue';
import GeImageFilter from './ge-image-filter';

// Main component
Vue.component('ge-image-filter', GeImageFilter);

export default GeImageFilter;



// WEBPACK FOOTER //
// ./scripts/ge-image-filter/index.js